<script lang="ts">
  import { createEventDispatcher, onDestroy } from "svelte";
  import { t } from "../../stores/translations";
  import { bodyDimensions } from "../../stores/bodyDimensions";

  export let question;
  export const selectedId: number = -1;
  export const properties = {};

  let debounceTimer: number;

  const dispatch = createEventDispatcher();

  onDestroy(() => {
    $bodyDimensions[question.slug].length = null;
    $bodyDimensions[question.slug].weight = null;
  });

  function positiveOnly(event) {
    if (event.keyCode === 45) event.preventDefault();
  }

  function select() {
    const length = $bodyDimensions[question.slug].length;
    const weight = $bodyDimensions[question.slug].weight;

    if (!length || !weight) return;

    // Calculate BMI
    const lengthInMeters = length / 100;
    const bmi = weight / (lengthInMeters * lengthInMeters);

    bodyDimensions.update((bodyDimensions) => {
      bodyDimensions[question.slug] = Object.assign(
        bodyDimensions[question.slug],
        { bmi }
      );

      return bodyDimensions;
    });

    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
      dispatch("select", question.answers[0]);
    }, 300);
  }
</script>

<section>
  <label>
    {$t(`questions.${question.slug}.labels.length-in-cm`)}

    <input
      min="0"
      max="280"
      type="number"
      bind:value={$bodyDimensions[question.slug].length}
      placeholder={$t(`questions.${question.slug}.placeholders.length`)}
      on:keypress={positiveOnly}
      on:input={select}
    />
  </label>

  <label>
    {$t(`questions.${question.slug}.labels.weight-in-kg`)}

    <input
      min="0"
      max="650"
      type="number"
      bind:value={$bodyDimensions[question.slug].weight}
      placeholder={$t(`questions.${question.slug}.placeholders.weight`)}
      on:keypress={positiveOnly}
      on:input={select}
    />
  </label>
</section>

<style lang="scss">
  @import "src/lib/styles/variables";
  @import "src/lib/styles/mixins";

  section {
    & > label {
      display: flex;
      flex-direction: column;
      color: $color-text;
      font-size: $font-size-medium;
      line-height: $font-size-extra-large;
      font-family: "Roboto";
      font-weight: $font-weight-bold;

      & > input {
        margin: 0.5rem 0 1rem;
        height: 48px;
        border: 2px solid $color-disabled;
        border-radius: 4px;
        padding: 0 1rem;
        color: $color-text;
        font-size: $font-size-small;
        outline: none;

        &:focus {
          border-color: $color-primary;
        }
      }
    }
  }

  @include desktop {
    section {
      display: flex;
      gap: 1rem;

      label {
        flex: 1;
        input {
          font-size: $font-size-medium;
        }
      }
    }
  }
</style>
